<template>
  <modal
    :id="modalId"
    :visible="!!formControl"
    :title="title"
    :button1-caption="capitalize($t('actions.save'))"
    :button2-caption="capitalize($t('actions.cancel'))"
    :button2-visible="true"
    :use-full-width="false"
    :button1-disabled="!canSave"
    @confirmed="save"
    @cancelled="onClose"
    @button1-clicked="onClose">
    <template #modal-after-form>
      <text-form-field
        :id="inputId"
        :control="formControl"
        name="name"
        :label="capitalizeTranslation('names.viewName')"
        @value-changed="onValueChanged"
        @enter-pressed="save" />

      <div class="form-group row">
        <div class="col-sm-3">
          <label>
            <span>{{ capitalize($t('names.default')) }}</span>
          </label>
        </div>

        <div class="col-sm-8">
          <toggle-button
            :color="Colors.success"
            :value="isDefault"
            :sync="true"
            @click.stop.prevent=""
            @change="isDefault = !isDefault" />
        </div>
      </div>
    </template>
  </modal>
</template>

<script lang="ts" setup>
  import { capitalize, computed, onMounted, ref } from 'vue';

  import Colors from '@/Colors';
  import Modal from '@/common/components/controls/Modal.vue';
  import ToggleButton from '@/common/components/controls/ToggleButton.vue';
  import FormControl from '@/common/components/generic-form/form-controls/FormControl';
  import DefaultValidator from '@/common/components/generic-form/form-controls/validator/DefaultValidator';
  import TextFormField from '@/common/components/generic-form/TextFormField.vue';
  import { capitalizeTranslation } from '@/globals';

  const emits = defineEmits(['save', 'close']);

  const modalId = 'add-view-modal';
  const inputId = 'view-name';

  const formControl = ref<FormControl<string>>(null);
  const isDefault = ref(false);

  const title = computed(() => capitalizeTranslation('messages.saveYourView'));

  const canSave = computed<boolean>(() => !!formControl.value?.value);

  function onClose() {
    emits('close');
  }

  function onValueChanged() {
    const { value } = formControl.value;
    formControl.value.update(value);
  }

  function save() {
    if (!canSave.value) return;
    emits('save', { name: formControl.value.value, isDefault: isDefault.value });
  }

  onMounted(() => {
    formControl.value = new FormControl<string>('', [DefaultValidator.required]);
  });
</script>
